export enum MeetingPlace {
  Clinic = 'Clinic',
  Teleconsultation = 'Teleconsultation',
}
